import { render, staticRenderFns } from "./packageCenterList.vue?vue&type=template&id=4a5e9840&scoped=true&"
import script from "./packageCenterList.vue?vue&type=script&lang=js&"
export * from "./packageCenterList.vue?vue&type=script&lang=js&"
import style0 from "./packageCenterList.vue?vue&type=style&index=0&id=4a5e9840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e9840",
  null
  
)

export default component.exports